import { render, staticRenderFns } from "./OrderCommentText.vue?vue&type=template&id=f24a050c&"
import script from "./OrderCommentText.vue?vue&type=script&lang=ts&"
export * from "./OrderCommentText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports